import { useMsal } from '@azure/msal-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch, type DirectoryUser } from './client';

// On-demand search (not a standing query) so we can surface the "not enabled"
// case cleanly.
export function useDirectorySearch() {
  const { instance } = useMsal();
  return (q: string) => apiFetch<DirectoryUser[]>(instance, `/api/directory/search?q=${encodeURIComponent(q)}`);
}

export function useInvite() {
  const { instance } = useMsal();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (u: DirectoryUser) =>
      apiFetch(instance, '/api/directory/invite', { method: 'POST', body: JSON.stringify(u) }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['users'] });
      qc.invalidateQueries({ queryKey: ['assignableUsers'] });
    },
  });
}
